import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowWallDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-wall-down, align bottom"} maskId="square-filled-radius-0-stroke-1-IconArrowWallDown"><path fillRule="evenodd" clipRule="evenodd" d="M12.5 2V16.2929L16.75 12.0429L17.4571 12.75L12 18.2071L6.54289 12.75L7.25 12.0429L11.5 16.2929V2H12.5ZM4 21H20V22H4V21Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowWallDown;
